export interface BytesConversionResult {
    bytes: number,
    kb?: number,
    mb?: number,
    gb?: number,
    tb?: number,
    pb?: number,
    eb?: number,
    zb?: number,
    yb?: number,
}

export const bytesConversion = (size = 0, decimals = 2): BytesConversionResult => {
    let bytes = size
    

    const k = 1024;
    let l = 0
    
    const result = {
        bytes: bytes
    }
    
    
    
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
    
    while (bytes >= k && ++l) {
        
        bytes = bytes / k
        
        result[sizes[l]] = parseFloat(bytes.toFixed(dm))
    }
    
    return result
}
